import { POE_AUTH_CONFIG } from '../types';

// PKCE utility functions as specified by GGG documentation and RFC 7636
export const generateRandomString = (length: number): string => {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
  let result = '';
  const randomValues = new Uint8Array(length);
  crypto.getRandomValues(randomValues);
  
  for (let i = 0; i < length; i++) {
    result += charset[randomValues[i] % charset.length];
  }
  
  return result;
};

export const generateCodeVerifier = (): string => {
  // Code verifier needs to be between 43-128 chars per RFC
  return generateRandomString(64);
};

export const generateCodeChallenge = async (verifier: string): Promise<string> => {
  // SHA-256 hash of verifier then base64url encode
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return base64URLEncode(new Uint8Array(digest));
};

export const base64URLEncode = (buffer: Uint8Array): string => {
  return btoa(String.fromCharCode.apply(null, Array.from(buffer)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
};

// Initiate OAuth flow with PKCE
export const initiatePoEAuthentication = async (): Promise<void> => {
  // Generate state for CSRF protection
  const state = generateRandomString(32);
  localStorage.setItem('oauth_state', state);

  // Generate code verifier and challenge using the proper method (RFC 7636)
  const codeVerifier = generateCodeVerifier();
  localStorage.setItem('code_verifier', codeVerifier);
  const codeChallenge = await generateCodeChallenge(codeVerifier);

  // Build the authorization URL
  const authUrl = new URL(POE_AUTH_CONFIG.authorizationBaseUrl);
  authUrl.searchParams.append('client_id', POE_AUTH_CONFIG.clientId);
  authUrl.searchParams.append('response_type', 'code');
  authUrl.searchParams.append('scope', POE_AUTH_CONFIG.scope);
  authUrl.searchParams.append('redirect_uri', POE_AUTH_CONFIG.redirectUri);
  authUrl.searchParams.append('state', state);
  authUrl.searchParams.append('code_challenge', codeChallenge);
  authUrl.searchParams.append('code_challenge_method', 'S256');

  // Redirect to PoE's authorization page
  window.location.href = authUrl.toString();
};